import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Flame, Layers } from "lucide-react";
import api from "../lib/api";
import { imgProps } from "../lib/img";
import { useCart } from "../context/CartContext";

const money = (n) => `$${(n || 0).toFixed(2)}`;

export default function OffersStrip({ businessId, onSelect }) {
  const [featured, setFeatured] = useState({ combos: [], items: [] });
  const navigate = useNavigate();
  const { channel } = useCart();

  useEffect(() => {
    api.get("/storefront/featured", { params: { ...(businessId ? { business_id: businessId } : {}), channel } })
      .then(({ data }) => setFeatured(data)).catch(() => {});
  }, [businessId, channel]);

  // A sold-out dish is never promoted, whatever the server sent
  const cards = [...featured.combos, ...featured.items].filter((p) => p.in_stock !== false);
  if (!cards.length) return null;

  const pick = (p) => {
    if (onSelect) onSelect(p);
    else navigate(`/store/${p.business_slug || "restaurant"}`, { state: { featuredId: p.id } });
  };

  return (
    <div className="mb-6" data-testid="offers-strip">
      <h2 className="font-display text-base font-extrabold tracking-tight mb-2.5 flex items-center gap-2">
        <Flame size={16} className="text-[#E04F33]" aria-hidden="true" /> Offers for you
      </h2>
      <div className="flex gap-3 overflow-x-auto pb-2 -mx-1 px-1">
        {cards.slice(0, 10).map((p) => (
          <button type="button" key={p.id} data-testid={`featured-card-${p.id}`} onClick={() => pick(p)}
            aria-label={`View ${p.name}`}
            className="shrink-0 w-64 bg-white border border-dashed border-[#E04F33]/50 rounded-2xl p-3 text-left cursor-pointer hover:border-[#E04F33] hover:shadow-md transition-all flex gap-3 items-center">
            {p.image && <img {...imgProps(p.image, [320], "56px")} alt={p.name} width="56" height="56" className="w-14 h-14 rounded-xl object-cover shrink-0" loading="lazy" />}
            <div className="min-w-0">
              <span className={`inline-flex items-center gap-1 text-[10px] font-bold rounded-md px-1.5 py-0.5 ${p.type === "combo" ? "bg-[#14532D]/10 text-[#14532D]" : "bg-[#E04F33]/10 text-[#E04F33]"}`}>
                {p.type === "combo" ? <><Layers size={10} /> COMBO</> : <><Flame size={10} /> CHEF'S PICK</>}
              </span>
              <p className="font-display font-extrabold text-sm leading-tight mt-1 truncate">{p.name}</p>
              <p className="text-xs mt-0.5">
                <span className="font-bold text-[#E04F33]">{money(p.display_price)}</span>
                {p.on_sale && p.regular_price > p.display_price && (
                  <>
                    <s className="ml-1.5 text-neutral-400">{money(p.regular_price)}</s>
                    <span className="ml-1.5 font-bold text-green-600">Save {money(p.regular_price - p.display_price)}</span>
                  </>
                )}
                {p.lead_time_hours ? <span className="ml-1.5 text-[10px] font-semibold text-amber-600">24-hr notice</span> : null}
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
